import React, { useRef, useEffect, useState } from "react";

const ScratchCard = () => {
  const canvasRef = useRef(null);
  const [isScratched, setIsScratched] = useState(false);
  const [message, setMessage] = useState("Congratulations! You have won a reward!");

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Set up scratch card area
    ctx.fillStyle = "#B0B0B0"; // Grey scratch area
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    let isDrawing = false;

    const scratch = (e) => {
      if (!isDrawing) return;

      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      ctx.globalCompositeOperation = "destination-out"; // Makes it transparent
      ctx.beginPath();
      ctx.arc(x, y, 20, 0, 2 * Math.PI);
      ctx.fill();

      checkScratchCompletion();
    };

    const startScratch = () => {
      isDrawing = true;
    };

    const endScratch = () => {
      isDrawing = false;
    };

    const checkScratchCompletion = () => {
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      let scratchedPixels = 0;
      const totalPixels = imageData.data.length / 4;

      for (let i = 0; i < totalPixels; i++) {
        if (imageData.data[i * 4 + 3] === 0) {
          scratchedPixels++;
        }
      }

      if ((scratchedPixels / totalPixels) * 100 > 70) {
        setIsScratched(true);
      }
    };

    canvas.addEventListener("mousedown", startScratch);
    canvas.addEventListener("mousemove", scratch);
    canvas.addEventListener("mouseup", endScratch);
    canvas.addEventListener("mouseleave", endScratch);

    return () => {
      canvas.removeEventListener("mousedown", startScratch);
      canvas.removeEventListener("mousemove", scratch);
      canvas.removeEventListener("mouseup", endScratch);
      canvas.removeEventListener("mouseleave", endScratch);
    };
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="relative w-64 h-64 flex items-center justify-center border-2 border-gray-400 rounded-lg bg-yellow-400">
        <div className="absolute inset-0 flex items-center justify-center text-lg font-bold text-black">
          {message}
        </div>
        {!isScratched && (
          <canvas ref={canvasRef} width={256} height={256} className="absolute top-0 left-0 rounded-lg" />
        )}
      </div>
    </div>
  );
};

export default ScratchCard;
